import { render } from "./IntShareModal.vue?vue&type=template&id=522c87d4&scoped=true"
import script from "./IntShareModal.vue?vue&type=script&lang=js"
export * from "./IntShareModal.vue?vue&type=script&lang=js"

import "./IntShareModal.vue?vue&type=style&index=0&id=522c87d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522c87d4"]])

export default __exports__